
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações Gerais',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-tipo',
        field: 'grau_estudo',
        label: 'Grau de Estudo',
        clearable: true,
        tipo: 122,
        valor:'valor',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'pa1',
        maxlength:3,
        label: 'Pressão Arterial Baixa (mmHg)',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'pa2',
        maxlength:3,
        label: 'Pressão Arterial Alta (mmHg)',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'peso',
        label: 'Peso (Kg)',
        mask: 'money',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'text',
        field: 'altura',
        label: 'Altura (metros)',
        mask:'money',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'ESTILO DE VIDA E ANTECEDENTES',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q18',
        label: 'Bebida Alcoólica',
        valor:'valor',
        tipo: 134,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q132',
        label: 'Tem boa Visão',
        valor:'id',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q164',
        label: 'Usa Óculos ou Lente de Contato',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q1128',
        label: 'Diabetes',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q1128',
        label: 'Pressão Alta',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q1128',
        label: 'Câncer',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q14',
        label: 'Fuma',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd14',
        label: 'Quantos cigarros ao dia/tempo',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q116',
        label: 'Pratica Esporte',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd116',
        label: 'Qual esporte e quantas vezes na semana',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q11024',
        label: 'Cirurgia ou Operação',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd11024',
        label: 'Quais',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q12048',
        label: 'Toma Algum Medicamento',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd12048',
        label: 'Quais',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q14096',
        label: 'Alergia',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd14096',
        label: 'Quais',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q18192',
        label: 'Já Esteve Internado',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd18192',
        label: 'Porquê',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q116384',
        label: 'Já Recebeu Sangue de Alguém',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd116384',
        label: 'Quando',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q132768',
        label: 'Tem Alguma Doença',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd132768',
        label: 'Quais',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q165536',
        label: 'Algum Acidente de Trabalho',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd165536',
        label: 'Quando',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'q22',
        label: 'Tem Alguma Queixa',
        tipo: 131,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'qd22',
        label: 'Quais',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'PELE E MUCOSAS',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo-checkbox',
        field: 'q34',
        label: '',
        tipo: 139,
        valor:'valor',
        multiple:true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'CABEÇA E PESCOÇO',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo-checkbox',
        field: 'q44',
        label: '',
        tipo: 144,
        valor: 'valor',
        multiple: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'TÓRAX',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo-checkbox',
        field: 'q54',
        label: '',
        tipo: 152,
        valor: 'valor',
        multiple: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'ABDOME',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo-checkbox',
        field: 'q64',
        label: '',
        tipo: 158,
        valor:'valor',
        multiple: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'MÃOS/PUNHOS/OMBROS/COTOVELOS',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo-checkbox',
        field: 'q74',
        label: '',
        tipo: 164,
        valor: 'valor',
        multiple: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'MEMBROS INFERIORES',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo-checkbox',
        field: 'q84',
        label: '',
        tipo: 167,
        valor: 'valor',
        multiple: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'COLUNA',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo-checkbox',
        field: 'q94',
        label: '',
        tipo: 171,
        valor: 'valor',
        multiple: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'CONCLUSÃO MÉDICA',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-tipo',
        field: 'conclusao',
        label: 'Conclusão',
        valor:'valor',
        tipo: 180,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'observacoes',
        label: 'Observações Gerais',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/credenciada/consulta/_form/consulta-config-femo.js